module.exports = __webpack_public_path__ + "assets/img/index-role2.920004fb.png";